module.exports = __webpack_public_path__ + "./img/stock-none.445c79b3ea7947fe71499fa15830cb2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stock-none.png
// module id = ./src/assets/img/stock-none.png
// module chunks = 11